import { useField } from 'react-final-form'
import useTranslate from '../../i18n/useTranslate'
import { composeValidators, textRequired } from '../../utilities/validate'
import { UseTextfieldProps } from './textfieldType'

export type FieldRequired = boolean | { showAsterisk?: boolean; triggedValidate?: boolean; errorMessage?: string }

function useTextfield(props: UseTextfieldProps) {
    const { name, required, validates = [] } = props
    const translate = useTranslate()
    let mergeValidate = validates
    if ((typeof required === 'boolean' && required) || (typeof required === 'object' && required.triggedValidate)) {
        mergeValidate = [
            textRequired(typeof required === 'object' ? required.errorMessage : `${translate.get('MESSAGE.M015')}`),
            ...mergeValidate,
        ]
    }
    /* Validate */
    const field = useField<string>(name, {
        validate: composeValidators(...mergeValidate),
    })

    return { field }
}

export default useTextfield
